import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext } from '@reveni-io/reveni-ui'

const useConsentCheckbox = ({ onConfirm }) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)
  const [checked, setChecked] = useState(false)
  const [confirmAttempted, setConfirmAttempted] = useState(false)

  const handleChange = event => setChecked(event.target.checked)

  const handleConfirm = () => {
    if (checked) return onConfirm()

    setConfirmAttempted(true)
    setToastInfo({ show: true, message: t('Campos obligatorios incompletos'), type: 'error' })
  }

  return { checked, showError: confirmAttempted && !checked, handleChange, handleConfirm }
}

export default useConsentCheckbox
